/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { CountAdjReasonList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const countAdjReasonList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedResources: INITIAL_STATE.selectedResources,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const countAdjReasonList01FetchCountAdjReasonList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const countAdjReasonList01FetchCountAdjReasonList01Success = (
  state,
  { resources, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  resources,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const countAdjReasonList01AddSelectedResources = (state, { selectedResources }) => {
  const selectIds = state.selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: [
      ...state.selectedResources,
      ...selectedResources.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const countAdjReasonList01RemoveSelectedResources = (state, { selectedResources }) => {
  const selectIds = selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: state.selectedResources.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const countAdjReasonList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [CountAdjReasonList01Types.COUNT_ADJ_REASON_LIST01_RESET_TIMESTAMP]: countAdjReasonList01ResetTimestamp,
  [CountAdjReasonList01Types.COUNT_ADJ_REASON_LIST01_FETCH_COUNT_ADJ_REASON_LIST01_LOADING]: countAdjReasonList01FetchCountAdjReasonList01Loading,
  [CountAdjReasonList01Types.COUNT_ADJ_REASON_LIST01_FETCH_COUNT_ADJ_REASON_LIST01_SUCCESS]: countAdjReasonList01FetchCountAdjReasonList01Success,
  [CountAdjReasonList01Types.COUNT_ADJ_REASON_LIST01_ADD_SELECTED_RESOURCES]: countAdjReasonList01AddSelectedResources,
  [CountAdjReasonList01Types.COUNT_ADJ_REASON_LIST01_REMOVE_SELECTED_RESOURCES]: countAdjReasonList01RemoveSelectedResources,
  [CountAdjReasonList01Types.COUNT_ADJ_REASON_LIST01_SET_WORKSPACE_VISIBLE]: countAdjReasonList01SetWorkspaceVisible
});
